// extracted by mini-css-extract-plugin
export default {"footer-card":"FooterCard_footer-card__ehXcT","footer-info":"FooterCard_footer-info__LO1QW","activeLink":"FooterCard_activeLink__ZfdE1"};